export const DMI_SELECTOR = '.js-import';
